// eslint-disable-next-line import/prefer-default-export
export const DiscussionType = {
  review: 'dealreview',
  question: 'dealcomment',
};
